import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { AnchorIcon } from "@/components/icons/AnchorIcon";

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-gradient-hero flex items-center justify-center">
      <div className="container mx-auto px-6">
        <div className="max-w-lg mx-auto text-center text-white">
          <div className="w-20 h-20 rounded-full bg-accent/20 flex items-center justify-center mx-auto mb-8">
            <CheckCircle2 className="h-10 w-10 text-accent" />
          </div>
          
          <div className="flex items-center justify-center gap-2 mb-6">
            <AnchorIcon className="h-8 w-8" />
            <span className="text-2xl font-bold">HostCaptain</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Thank You!
          </h1>
          
          <p className="text-xl text-white/80 mb-8">
            You're on the list! We'll be in touch soon with early access to HostCaptain.
          </p>
          
          <Link to="/">
            <Button className="bg-gradient-primary text-primary-foreground hover:opacity-90">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
